import React, { useState, useEffect } from 'react';
import './musichistory.css';
import ApiService from './services/api';

const MusicHistory = () => {
  const [uploadHistory, setUploadHistory] = useState([]);
  const [usernameFilter, setUsernameFilter] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [dateFilter, setDateFilter] = useState('');
  const [filteredHistory, setFilteredHistory] = useState([]);
  const [loadError, setLoadError] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        setLoadError('');
        const data = await ApiService.listMusicUploads({ includeInitiated: false });
        if (cancelled) return;
        const history = data?.data?.historyRows || data?.historyRows || [];
        const rows = Array.isArray(history) ? history : [];
        setUploadHistory(rows);
        setFilteredHistory(rows);
      } catch (err) {
        if (cancelled) return;
        console.error('Failed to load music history', err);
        setLoadError(err?.message || 'Failed to load music history');
        setUploadHistory([]);
        setFilteredHistory([]);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const uniqueUsernames = [...new Set(uploadHistory.map((item) => item.username).filter(Boolean))];
  const uniqueStatuses = [...new Set(uploadHistory.map((item) => item.status).filter(Boolean))];

  const filterHistory = (username, status) => {
    const filtered = uploadHistory.filter(
      (item) =>
        String(item.username || '')
          .toLowerCase()
          .includes(String(username || '').toLowerCase()) &&
        String(item.status || '')
          .toLowerCase()
          .includes(String(status || '').toLowerCase()),
    );
    setFilteredHistory(filtered);
  };

  const handleUsernameChange = (e) => {
    const value = e.target.value;
    setUsernameFilter(value);
    filterHistory(value, statusFilter);
  };

  const handleStatusChange = (e) => {
    const value = e.target.value;
    setStatusFilter(value);
    filterHistory(usernameFilter, value);
  };

  const handleReset = () => {
    setUsernameFilter('');
    setStatusFilter('');
    setDateFilter('');
    setFilteredHistory(uploadHistory);
  };

  return (
    <>
      <h1>Music History</h1>
      <div className="history-content">
        {loadError ? (
          <div className="error-message" style={{ marginBottom: '1rem' }}>
            {loadError}
          </div>
        ) : null}
        <div className="filters">
          <div className="filter-group">
            <label>Username</label>
            <div className="select-search-container">
              <input
                type="text"
                value={usernameFilter}
                onChange={handleUsernameChange}
                placeholder="Any username"
                list="usernames"
                className="select-search-input"
              />
              <datalist id="usernames">
                <option value="">Any username</option>
                {uniqueUsernames.map((username, index) => (
                  <option key={index} value={username}>
                    {username}
                  </option>
                ))}
              </datalist>
            </div>
          </div>
          <div className="filter-group">
            <label>Status</label>
            <div className="select-search-container">
              <input
                type="text"
                value={statusFilter}
                onChange={handleStatusChange}
                placeholder="Any status"
                list="statuses"
                className="select-search-input"
              />
              <datalist id="statuses">
                <option value="">Any status</option>
                {uniqueStatuses.map((status, index) => (
                  <option key={index} value={status}>
                    {status}
                  </option>
                ))}
              </datalist>
            </div>
          </div>
          <div className="filter-group date-range">
            <label>Last Uploaded</label>
            <div className="select-search-container">
              <input
                type="text"
                value={dateFilter}
                onChange={(e) => setDateFilter(e.target.value)}
                placeholder="Start Date    End Date"
                className="select-search-input"
              />
            </div>
          </div>
          <button className="history-reset-btn" onClick={handleReset}>
            Reset All
          </button>
        </div>

        <div className="history-table">
          <table className="upload-table">
            <thead>
              <tr>
                <th>Username</th>
                <th>File Name</th>
                <th>File Size</th>
                <th>Upload Date</th>
                <th>Upload Time</th>
                <th>Company</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {filteredHistory.map((upload, index) => (
                <tr key={upload.uploadId || index}>
                  <td>{upload.username}</td>
                  <td>{upload.fileName}</td>
                  <td>{upload.fileSize}</td>
                  <td>{upload.uploadDate}</td>
                  <td>{upload.uploadTime}</td>
                  <td>{upload.companyName}</td>
                  <td
                    className={`status ${String(upload.status || '')
                      .toLowerCase()
                      .replace(/\s+/g, '-')}`}
                  >
                    {upload.status}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default MusicHistory;
